import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueSpinners from 'vue-spinners'

Vue.use(VueSpinners);
Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                primary: '#4BB79C',
                secondary: '#405d6e',
                accent: '#c69500',
                background: '#e5e5e5',
                info: '#8e9ea9',
                error: '#c75151'
            },
        },
    }
});
